const ko = {
    num: '숫자',
    operator: '운영자',
    oprtTime: '작업 시간',
    oprtType: '작업 유형',
    orderSource: '주문 소스',
    orderStatus: '주문 상태',
    orderType: '주문 유형',
    printCount: '인쇄 횟수',
    prdctName: '재고 이름',
    quantity: '수량',
    delTip1: '이 {{type}} 주문을 삭제하시겠습니까?',
    delTip2: '삭제 후 이 {{type}} 주문의 데이터를 복구할 수 없습니다',
    delSucc: '성공적으로 삭제되었습니다',
    delFail: '삭제 실패, {{content}}',
    orderDetails: '주문 세부 정보',
    cancel: '취소',
    confirm: '확인',
    confirm2: '확인',
    basicData: '기본 데이터',
    goods: '상품',
    verificaFailed: '검증 실패',
    amountTip1: '제품의 수량은 0보다 커야 합니다',
    amountTip2: '제품명과 수량 형식은 정확해야 합니다',
    aplicatForm: '신청서',
    prdctList: '제품 목록',
    fillQuantity: '{{type}} 수량을 입력해 주세요',
    next: '다음 단계',
    noGood: '창고에 이 제품이 없습니다',
    modificatFailed: '수정 실패',
    tradeName: '제품 이름',
    brand: '모델',
    desc: '설명',
    unit: '단위',
    inboundOprt: '창고에 들어가고 싶어요',
    outboundOprt: '배송하고 싶어요',
    addFailed: '추가 실패',
    prdctSource: '제품 소스',
    basicInfo: '기본 정보',
    creator: "작성자",
    createdAt: "작성 시간",
    preparedBy: '작성자',
    preparationTime: '작성 시간',
    operationSource: '작업 소스',
    operationStatus: '작업 상태',
    inTransit: '운송 중',
    inboundCompleted: '입고 완료',
    preparing: '준비 중',
    outboundCompleted: '출고 완료',
    modifyFail: '인벤토리 수정 실패',
    sameCodeTip1: '같은 바코드가 있습니다. 확인해 주세요',
    view: '보기',
    noScanOrder: '스캔 순서가 존재하지 않습니다',
    temStorage: '임시 저장소',
    repeatInTip: '바코드 {{code}}이 이미 존재하므로 다시 입력할 수 없습니다. ',
    plFillInData: '데이터를 입력해주세요',
    plFillInDataCompletely: '데이터를 모두 입력해 주세요! ',
    tip: '팁',
    cancelTip1: '현재 이용 가능한 데이터가 있습니다. 취소하시겠습니까? ',
    sameCodeSel: '바코드 선택 반복',
    sameCode: '바코드 반복:',
    plSelSpecifiedProduct: '작동할 지정된 제품을 선택하세요:',
    productTitle: '제품',
    productCode: '제품 코드',
    barcode: '바코드',
    viewCode: '바코드 보기',
    copySuccess: '복사 성공! ',
    copyFail: '복사 실패! ',
    codeListWithCount: '바코드 목록이 있습니다(총: {{count}})',
    copyAll: '한번 클릭으로 복사',
    conDelTip1: '창고에 중복된 바코드가 있습니다. 다음 바코드를 삭제하시겠습니까? ',
    conDelTip2: '이 제품의 바코드는 창고에 없습니다. 다음 바코드를 삭제하시겠습니까? ',
    operationSucc: '작업 성공',
    saveSucTip: '임시 저장이 성공하였습니다. 주문 목록에서 데이터 작업을 할 수 있습니다! ',
    saveFailTip: '임시 저장소에 실패했습니다. {{err}}',
    fetchBarcodesFailt: '바코드 쿼리에 실패했습니다. {{err}}',
    searchPl: '검색할 키워드를 입력하세요',
    searchByOrderNumber: '주문 번호를 입력하여 검색하세요',
    startTime: '시작 시간',
    endTime: '종료 시간',
    confirmTip: '다음 바코드는 창고에 있는 제품과 일치하지 않습니다',
    serialMumber: '일련 번호',
    barcodesNumber: '바코드 수',
    addDataTip: '먼저 데이터를 추가하세요',
    selectChangeTypePl: '작업 유형을 선택하세요',
    preTime: '배송 시간',
    confirmedTime: '실제 입출고 시간',
    editOrder: '주문 편집',
    quantityConfirm: '수량 확인',
    updateOrderSuccess: '주문 업데이트 성공',
    onOrders: '대량 주문',
    ordersComfirm: '대량 주문 확인?',
    optErr: "작업 실패",
    signed: '서명됨',
    noChanges: '변경 없음',
    inOutNo: "입출고 주문",
    remark: '비고',
    saleOut: "판매 출고",
    calcOut: "출고 데이터 계산",
    saledQty: "판매 완료 수량",
    productionInCount: "생산 입고 수량",
    toSaledQty: "출고 대기 수량",
    curSaledQty: "금회 판매 수량",
    zeroTip: "최소 하나의 자재 금회 판매 수량이 0보다 커야 합니다",
    orderSucc: "판매 출고 주문이 생성되었습니다",
    orderErr: "판매 출고 주문 생성 실패",
    preOut: "재고 할당",
    needPre: "판매 출고 주문에 먼저 재고를 할당하세요!",
    preOutSucc: "재고 할당 성공",
    preOutErr: "재고 할당 실패",
    orderContitle: "판매 사전 출고 주문을 생성하시겠습니까?",
    outOvernum: "사용된 재고량이 가용 재고량을 초과했습니다",
    isSwap: "전환 주문 문서 여부",
};

export default ko;
